import React from "react";

import { css } from "@compiled/react";
import { UniformSlot } from "@uniformdev/canvas-react";

import { spaceTokenValues } from "../../utils";

export interface UniformListProps {
    gap: keyof typeof spaceTokenValues;
    maxHeight?: number;
    isHorizontal: boolean;
}

export const UniformList: React.FC<UniformListProps> = ({
    gap = "space.100",
    maxHeight,
    isHorizontal = false
}) => {
    const spaceTokenValue = spaceTokenValues[gap];
    const listStyle = css({
        display: "flex",
        flexDirection: isHorizontal ? "row" : "column",
        gap: "var(--ds-space-" + spaceTokenValue + ")",
        maxHeight: maxHeight ? maxHeight + "px" : "none",
        overflow: "hidden"
    });

    return (
        <div css={listStyle}>
            <UniformSlot name="listItems" />
        </div>
    );
};

export default UniformList;
